export default {
    "name": "GetStaticMap",
    "kind": "HoudiniQuery",
    "hash": "a91e4d41e00ce24fcef1ed3ca58d06512d2479ddba793703d608b847cf5241bc",

    "raw": `query GetStaticMap($input: GetStaticMapInput!) {
  getStaticMap(input: $input) {
    ... on GetStaticMapSuccessResult {
      type
      width
      height
      copyright
      url
    }
    ... on GetStaticMapNotFoundResult {
      type
      message
    }
    __typename
  }
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "getStaticMap": {
                "type": "GetStaticMapResult",
                "keyRaw": "getStaticMap(input: $input)",

                "selection": {
                    "abstractFields": {
                        "fields": {
                            "GetStaticMapSuccessResult": {
                                "type": {
                                    "type": "GetStaticMapResultType",
                                    "keyRaw": "type",
                                    "visible": true
                                },

                                "width": {
                                    "type": "Float",
                                    "keyRaw": "width",
                                    "visible": true
                                },

                                "height": {
                                    "type": "Float",
                                    "keyRaw": "height",
                                    "visible": true
                                },

                                "copyright": {
                                    "type": "String",
                                    "keyRaw": "copyright",
                                    "visible": true
                                },

                                "url": {
                                    "type": "String",
                                    "keyRaw": "url",
                                    "visible": true
                                },

                                "__typename": {
                                    "type": "String",
                                    "keyRaw": "__typename",
                                    "visible": true
                                }
                            },

                            "GetStaticMapNotFoundResult": {
                                "type": {
                                    "type": "GetStaticMapResultType",
                                    "keyRaw": "type",
                                    "visible": true
                                },

                                "message": {
                                    "type": "String",
                                    "keyRaw": "message",
                                    "visible": true
                                },

                                "__typename": {
                                    "type": "String",
                                    "keyRaw": "__typename",
                                    "visible": true
                                }
                            }
                        },

                        "typeMap": {}
                    },

                    "fields": {
                        "__typename": {
                            "type": "String",
                            "keyRaw": "__typename",
                            "visible": true
                        }
                    }
                },

                "abstract": true,
                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "input": "GetStaticMapInput"
        },

        "types": {
            "CoordinatesInput": {
                "lat": "Float",
                "lng": "Float"
            },

            "GetStaticMapInput": {
                "center": "CoordinatesInput",
                "entityType": "AddressEntityType",
                "height": "Float",
                "style": "String",
                "width": "Float"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=4f05987fdc3873c4e88e0e01e33b329c5250ca700fd5f6433e58b2a8be5cf2f5";